<!-- Bar search -->
@if (appearance === 'bar') {
  <ng-container>
    @if (!opened) {
      <button mat-icon-button (click)="open()">
        <mat-icon [svgIcon]="'heroicons_outline:search'"></mat-icon>
      </button>
    } @if (opened) {
      <div class="absolute inset-0 flex items-center shrink-0 z-99 bg-card" style="margin-left: 70%" @slideInTop @slideOutTop>
        <mat-icon class="absolute ml-6 sm:ml-8" [svgIcon]="'heroicons_outline:search'"></mat-icon>
        <input class="w-full h-full px-16 sm:px-18" [formControl]="searchControl" [placeholder]="'Search...'" (keyup)="onKeydown($event)" #barSearchInput />
        <button class="absolute top-1/2 right-5 sm:right-7 shrink-0 w-10 h-10 -mt-5" mat-icon-button (click)="close()">
          <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
      </div>
    }
  </ng-container>
}
